/**
 * **Fusion**
 *
 * @exports bs_349
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};

  /**
     * @memberOf module:bs_349
     * @see {@link prestart}
     *
     * @param {object} ctx - The context object.
     */
  engine.boot = function boot() {

    const dataLayer = window.dataLayer;
    if (!dataLayer) {
      return;
    }
    thn.domReady().then(function () {
      let handler = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        const refreshPage = thn.debounce(thn.pageCheck, 700);
        if (message.event === 'VirtualPageView') {
          refreshPage();
        }
      }, true);
      thn.shutdown(() => {
        handler.cancel();
        handler = null;
      });
    });
  };

  /**
     * @memberOf module:bs_349
     * @see {@link is_user_logged}
     *
     * @param {object} ctx - The context object.
     */
  engine.isUserLogged = function isUserLogged(ctx) {

    const isLogged = false;

    return isLogged;
  };

  /**
     * @memberOf module:bs_349
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    const url = new URL(ctx.baseUrl);
    const validUrl = !!url.pathname.match(/zimmer|rooms|chambres|habitaciones|kamers|camere/);

    if (!validUrl) {
      ctx.newUrl = '';
      return ctx;
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
    * @memberOf module:bs_349
    * @this thn.widgets.price
    * @see {@link Price#observe_dom}
    *
    * @param {object} ctx - The context object.
    */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const dataLayer = window.dataLayer;

    if (!dataLayer || thn.fusionPriceRefresh) {
      return;
    }

    thn.fusionPriceRefresh = new thn.DataLayerHelper(window.dataLayer, thn.cancellable(function (model, message) {
      const isCalendarOpen = thn.isVisible(document.querySelector('#modal-calendar-guest'));
      if (message.event === 'VirtualPageView' && !isCalendarOpen) {
        ctx.widget.update();
      }
    }), true);

    thn.pageUnload(function () {
      thn.fusionPriceRefresh.cancel();
      delete thn.fusionPriceRefresh;
    });

  };

  /**
     * @memberOf module:bs_349
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const searchParameters = thn.objectGet(window.dataLayer, 'searchParameters', { first: false });
    if (!searchParameters) {
      return widgetData;
    }

    // Dates
    const dateBegin = thn.objectGet(searchParameters, 'checkinDate') || thn.objectGet(searchParameters, 'arrivalDate');
    const dateEnd = thn.objectGet(searchParameters, 'checkoutDate') || thn.objectGet(searchParameters, 'departureDate');
    let nights;
    if (dateBegin && dateEnd) {
      widgetData.dateBegin = dateBegin.replace(/-/g, '/');
      widgetData.dateEnd = dateEnd.replace(/-/g, '/');
      nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
    }

    // Guests, Adults & Children
    // The R&R page of some properties (e.g Hotal Gabriel Paris PID:1034056) shows sigle room rates even though the guest chosen is 2 adults.
    // It should be excluded that the maximum occupancy number of a room is less than the number of selected guests.
    const roomsList = thn.objectGet(searchParameters, 'rooms').filter((el) => el.adultCount >= searchParameters.adultCount);

    if (roomsList?.length) {
      roomsList.sort((a, b) => a.price - b.price);
      widgetData.adults = roomsList[0]?.adultCount;
      widgetData.children = roomsList[0]?.childCount;
      widgetData.guests = widgetData.adults + widgetData.children;
      const price = roomsList[0]?.price;
      const currency = thn.objectGet(searchParameters, 'currency');
      if (price && nights && currency) {
        widgetData.price = price / nights;
        widgetData.currency = currency;
        widgetData.set = true;
      }
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_349
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {
    const dataLayer = window.dataLayer;

    if (!dataLayer || thn.fusionBookingRefresh) {
      return;
    }
    const stopObserver = function () {
      thn.fusionBookingRefresh.cancel();
      delete thn.fusionBookingRefresh;
    };

    thn.fusionBookingRefresh = new thn.DataLayerHelper(window.dataLayer, thn.cancellable(function (model, message) {
      if (message.event === 'TransactionCompleted') {
        ctx.widget.save();
        stopObserver();
      }
    }), true);

    thn.pageUnload(stopObserver);
  };

  /**
     * @memberOf module:bs_349
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    const bookingObject = thn.objectGet(window.dataLayer, 'booking', { first: false });
    const bookingData = thn.dataLayerHelper.get('booking');
    const bookingId = thn.objectGet(bookingObject, 'reference') || document.querySelector('.booking-info__value')?.textContent || thn.parseUrlParameter('bookingReference');

    if (!bookingId) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.bookingId = bookingId;
    widgetData.dateBegin = (thn.objectGet(bookingObject, 'checkinDate') || bookingData?.checkinDate || thn.dataLayerHelper.get('context')?.searchParameters?.checkinDate)?.replace(/-/g, '/');
    widgetData.dateEnd = (thn.objectGet(bookingObject, 'checkoutDate') || bookingData?.checkoutDate || thn.dataLayerHelper.get('context')?.searchParameters?.checkoutDate)?.replace(/-/g, '/');
    widgetData.adults = thn.objectGet(bookingObject, 'adultCount') || bookingData?.adultCount;
    widgetData.children = thn.objectGet(bookingObject, 'childCount') || ((bookingData?.childCount ?? 0) + (bookingData?.infantCount ?? 0));
    widgetData.guests = widgetData.adults + widgetData.children;
    const price = document.querySelector('.basket__line_type_total .basket__line__price')?.textContent;
    widgetData.currency = thn.objectGet(bookingObject, 'currencies')?.invoiced || bookingData?.currencies?.invoiced || thn.parseCurrency(price);
    widgetData.price = thn.objectGet(bookingObject, 'total')?.totalPrice?.invoiced || bookingData?.total_price || thn.objectGet(bookingObject, 'total_price') || thn.parseNumber(price);

    return widgetData;
  };

  return engine;

}

export { factory };
